import React, {ChangeEvent, ChangeEventHandler} from "react"
import Card from "../../../../containers/Card/Card"
import CheckboxField from "../../../CheckboxField/CheckboxField"
import {Box} from "../../../../containers/Box/Box"
import {ErrorMessage, FormikProps} from "formik"
import AcceptableTypesOfIdentificationSubtitle from "../AcceptableTypesOfIdentificationSubtitle"
import {
	AcceptableTypesOfIdentificationType,
	CheckboxStructure,
	hasExceptionsOnAcceptableTypesOfIdentification,
} from "../../RiskSettingsUtils"
import TitleWithBadge from "../../../TitleWithBadge/TitleWithBadge"

interface AcceptableTypesOfIdentificationProps {
	value: AcceptableTypesOfIdentificationType
	defaultValue?: AcceptableTypesOfIdentificationType
	name: string
	handleChange: FormikProps<AcceptableTypesOfIdentificationType>["handleChange"]
	setFieldTouched: FormikProps<AcceptableTypesOfIdentificationType>["setFieldTouched"]
	checkboxStructure: CheckboxStructure
}

interface BoxCheckboxFieldProps {
	name: string
	label: string
	checked: boolean
	handleChange: ChangeEventHandler<HTMLInputElement>
}

function BoxCheckboxField({name, label, checked, handleChange}: BoxCheckboxFieldProps) {
	return (
		<Box className="box-with-custom-padding">
			<CheckboxField name={name} label={label} checked={checked} onChange={handleChange} light />
		</Box>
	)
}

export default function AcceptableTypesOfIdentificationEditMode({
	value,
	defaultValue,
	name,
	handleChange,
	setFieldTouched,
	checkboxStructure,
}: AcceptableTypesOfIdentificationProps) {
	return (
		<div className="risk-settings-card">
			<Card
				title="Acceptable Types of Identification"
				subtitle={<AcceptableTypesOfIdentificationSubtitle />}
				className="header-with-large-gap"
				icon="user-id-cards---users"
			>
				<div className="acceptable-types-of-identification">
					{checkboxStructure.map(({group, title, items}) => (
						<div className="values-section" key={group}>
							<TitleWithBadge
								title={title}
								showBadge={
									defaultValue && hasExceptionsOnAcceptableTypesOfIdentification(value[group], defaultValue[group])
								}
								badgeText="Exceptions"
								badgeTooltip={`This onboarding rules for this Org<br>
									include exceptions to the bank's<br>
									default onboarding rules.`}
								badgeTooltipClassname="risk-settings-badge-tooltip"
								badgeTooltipKey={`${group}-badge-tooltip`}
								heading="h3"
							/>
							{items.map(({name: checkboxName, label}) => {
								const checkboxPath = `${name}.${group}.${checkboxName}`
								return (
									<BoxCheckboxField
										key={checkboxName}
										name={checkboxPath}
										label={label}
										checked={value[group][checkboxName]}
										handleChange={(e: ChangeEvent<HTMLInputElement>) => {
											handleChange(e)
											setFieldTouched(e.target.name, true, false)
										}}
									/>
								)
							})}
							<ErrorMessage name={`${name}.${group}`} component="div" className="form-error" />
						</div>
					))}
				</div>
			</Card>
		</div>
	)
}
